import React, { useRef, useState } from "react";
import { FiRepeat } from "react-icons/fi";
import { displayDate } from "../lib/activitySchedule";

export default function TodayScheduledActivities({ date, activities, loading, error, onToggle }) {
  const pending = useRef(new Set());
  const [busy, setBusy] = useState([]);

  async function toggle(activity, completada) {
    if (pending.current.has(activity._id)) return;
    pending.current.add(activity._id); setBusy([...pending.current]);
    try { await onToggle({ fechaIso: date, obsId: activity._id, completada }); }
    finally { pending.current.delete(activity._id); setBusy([...pending.current]); }
  }

  return <aside className="weekly-scheduled-today" aria-labelledby="weekly-scheduled-today-title">
    <header>
      <h3 id="weekly-scheduled-today-title"><FiRepeat aria-hidden="true" /> Actividades de hoy</h3>
      <p>Programadas para el {displayDate(date)}</p>
    </header>
    <div className="weekly-scheduled-today-list" aria-busy={loading}>
      {loading ? <p className="weekly-scheduled-message" role="status">Cargando actividades…</p>
        : error ? <p className="weekly-scheduled-error" role="alert">{error}</p>
        : !activities.length ? <p className="weekly-scheduled-message">No hay actividades programadas para hoy.</p>
        : activities.map((activity) => <article key={activity._id} className={`weekly-scheduled-card${activity.completada ? " done" : ""}`}>
          <label>
            <input type="checkbox" checked={!!activity.completada} disabled={busy.includes(activity._id)}
              onChange={(event) => toggle(activity, event.target.checked)} />
            <span>{activity.observacion}</span>
          </label>
          <div className="weekly-scheduled-card-meta">
            <span>{String(activity.ambito).toLowerCase() === "fiscal" ? "Origen fiscal" : "Origen nacional"}</span>
            <small>{activity.completada ? "Completada" : "Pendiente"}</small>
          </div>
        </article>)}
    </div>
  </aside>;
}
